<template>
    <div class="main">
        <header>
            <a class="header_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/ubiadmin/AdminStaffList">スタッフ一覧</router-link>
                <router-link class="header_link" to="/ubiadmin/AdminNewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn" v-on:click="logout">ログアウト</button>
            </div>
        </header>
        <h3 v-show="err_catch" class="err_msg">エラー発生!!!!</h3>
        <h1>スタッフ一覧</h1>
        <div class="search_register_btn">
            <router-link class="register_btn" to="/ubiadmin/AdminStaffEdit">CSVアップロード</router-link>
        </div>
        <div class="number">
            <p>{{ getMinPage }}〜{{ getMaxPage }}／{{ get_page }}件</p>
        </div>
        <div class="news_list_tables">
            <!-- <table>
                <tr class="header_tr">
                    <th class="small_list">管理番号</th>
                    <th>名前</th>
                    <th class="max_width">メールアドレス</th>
                    <th>最終ログイン日時</th>
                    <th>最終既読ニュース</th>
                    <th>登録者</th>
                    <th>登録日時</th>
                    <th>更新者</th>
                    <th>更新日時</th>
                </tr>
            </table> -->
            <div class="news_list">
                <table>
                    <tr class="header_tr">
                        <th>管理番号</th>
                        <th>名前</th>
                        <th class="max_width">メールアドレス</th>
                        <th>最終ログイン日時</th>
                        <th class="max_width2">最終既読ニュース</th>
                        <th>登録者</th>
                        <th>登録日時</th>
                        <th>更新者</th>
                        <th>更新日時</th>
                    </tr>
                    <tr v-for="e in getLists" :key="e.id">
                        <td>{{ e.staff_id }}</td>
                        <td>{{ e.name }}</td>
                        <td class="max_width">{{ e.email }}</td>
                        <td v-if="e.last_login==Null">-</td>
                        <td v-else>{{ e.last_login | moment("YYYY/MM/DD") }}<br>{{ e.last_login | moment("HH:mm:ss") }}</td>
                        <td v-if="e.last_read_notice==Null">-</td>
                        <td class="max_width2" v-else>{{e.last_read_notice}}</td>
                        <td>{{ e.create_user }}</td>
                        <td>{{ e.create_date | moment("YYYY/MM/DD") }}<br>{{ e.create_date | moment("HH:mm:ss") }}</td>
                        <td>{{ e.update_user }}</td>
                        <td>{{ e.update_date | moment("YYYY/MM/DD") }}<br>{{ e.update_date | moment("HH:mm:ss") }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <paginate
            :v-model="currentPage"
            :page-count="getPageCount"
            :click-handler="clickCallback"
            :page-range="3"
            :margin-pages="2"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-link-class="'page-link'"
            :hide-prev-next="true"
            >
        </paginate>
        <div class="back_btn">
            <router-link to="/ubiadmin/AdminTop">戻る</router-link>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      tweets: [],
      err_catch: false,
      currentPage: 1,
      parPage: 50,
      get_page: 0,
      url_protcol: 'https://',
      domain: '1304kanri.ubiquitous-p.com',
      url_path: '/rest/get_staff_list/'
    }
  },
  mounted () {
    this.fetchTweets() // fetchTweetsを呼ぶ
  },
  methods: {
    fetchTweets () {
      axios
        .post(this.url_protcol + this.domain + this.url_path,{},{
            headers: {
                "Content-Type": "application/json", 
                "Authorization": this.$store.state.userToken 
            }
        })
        .then(response => {
          this.tweets = response.data
          this.get_page = response.data.length
        }).catch(error => {
          this.err_catch = true
          console.log(error)
        })
    },
    clickCallback: function (pageNum) {
      this.currentPage = Number(pageNum)
    },
    logout() {
        this.$store.commit('reset');
        this.$router.push({name:'aLogin'});
    }
  },
  computed: {
    getLists: function () {
      let current = this.currentPage * this.parPage
      let start = current - this.parPage
      return this.tweets.slice(start, current)
    },
    getPageCount: function () {
      return Math.ceil(this.tweets.length / this.parPage)
    },
    getMaxPage: function () {
      if (this.getLists.length === 50) {
        let max = this.currentPage * 50
        return max
      } else {
        let page = this.currentPage - 1
        let max = 50 * page + this.getLists.length
        return max
      }
    },
    getMinPage: function () {
      if (this.getLists.length === 0) {
        return 0
      } else {
        let min = 50 * this.currentPage - 49
        return min
      }
    }
  }
}
</script>

<style scoped>

.main {
    width: 100vw;
    background-size: cover;
}

a.register_btn {
    width: fit-content;
    display: block;
    background-color: #4DC0AD;
    color: #fff;
    border-radius: 10px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    padding: 5px 40px;
    margin-left: auto;
}

h1 {
    margin: 10px 30px;
}

.search_register_btn {
    display: flex;
    width: 95vw;
    margin: 20px auto 0;
}

.search_wrap {
    display: flex;
    align-items: center;
}

.search_wrap button {
    width: fit-content;
    display: block;
    background-color: #4DC0AD;
    color: #fff;
    border-radius: 10px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    padding: 5px 40px;
    margin: 0 3vw 0 auto;
    border: none;
}

.search_wrap input {
    display: block;
    width: 250px;
    height: 30px;
    padding: 0 10px;
    border-radius: 10px;
    border: 1px solid #888;
    box-shadow: rgb(210 210 210) 1px 1px 3px inset;
}

.interval {
    margin-right: 20px;
}

.number {
    text-align: right;
    margin-right: 5vw;
}

.number p {
    font-size: .7em;
    margin: 5px 0;
}

.news_list_tables {
    width: 95vw;
    margin: 0 auto;
    padding: 20px 30px;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    box-shadow: rgb(228 228 228) 1px 1px 8px;
}

.news_list {
    width: 100%;
    height: 55vh;
    overflow: scroll;
}

table {
    width: 150%;
    border-collapse: collapse;
    position: relative;
}

td, tr, td a {
    font-size: 1em;
}

tr {
    border-bottom: 1px solid #707070;
    height: 50px;
}

th, td {
    text-align: left;
    word-break: break-all;
}

th.small_list, td.small_list {
    width: 60px;
    text-align: center;
}

td a {
    text-decoration: underline;
    color: blue;
}

.back_btn {
    width: 90vw;
    margin: 0 auto;
    padding: 15px;
}

.back_btn a {
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #4DC0AD;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
}

ul.pagination {
    width: fit-content;
    display: flex;
    margin: 2vw auto 0;
}

.err_msg {
    color: red;
    text-align: center;
}
th.max_width,td.max_width {
    width: 500px;
    padding-right: 40px;
}

th.max_width2,td.max_width2 {
    width: 245px;
    padding-right: 40px;
}


.header_tr{
    background: #fff;
    position: sticky;
    left: 0;
    top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminStaffList.vue